import React, { useEffect } from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import userActions from "../actions";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import PolygonMapSidebarChart from "./PolygonMapSidebarChart";
import ColoradoRiverAccessLocationFilter from "../ColoradoRiverAccessLocationFilter";
import { useHistory, useLocation } from "react-router";
// import { population } from "../constants";

function PolygonMapChartTab() {
  const {
    city_selected,
    city_water_sources,
    entity_entitlements,
    entitlements_by_year,
    cities_water_use,
    polgon_map_tab,
    entitlement_year,
    cities,
    scenario_selected,
    population,
  } = useSelector((state) => state.technical_view);

  const {
    setSelectedCity,
    loadEntityEntitlements,
    loadCityMetrics,
    loadCityWaterSources,
    setIsTribe,
    setIsWesternEntity,
    setIsCity,
  } = userActions();

  const classes = useStyles();

  const history = useHistory()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('type');
  const dropdown = params.get('dropdown');

  const chartDataWaterSources = [
    {
      name: "Agua Fria",
      y: Math.round(city_water_sources.percent_tap_agua_fria * 100),
      color: "#C33229",
    },
    {
      name: "Groundwater",
      y: Math.round(city_water_sources.percent_tap_groundwater * 100),
      color: "#FFB628",
    },
    {
      name: "Salt River & Verde",
      y: Math.round(city_water_sources.percent_tap_salt_and_verde * 100),
      color: "#6AA4DC",
    },
    {
      name: "Colorado River",
      y: Math.round(city_water_sources.percent_tap_colorado * 100),
      color: "#2352D0",
    },
  ];

  const chartDataWaterUse = [
    {
      name: "Aquifer Recharge",
      y: cities_water_use[city_selected.name]
        ? Math.round(
            cities_water_use[city_selected.name].percent_aquifer_recharge * 100
          )
        : 0,
      color: "#FFB607",
    },
    {
      name: "Agriculture",
      y: cities_water_use[city_selected.name]
        ? Math.round(
            cities_water_use[city_selected.name].percent_agriculture * 100
          )
        : 0,
      color: "#E0A45D",
    },
    {
      name: "Turf",
      y: cities_water_use[city_selected.name]
        ? Math.round(cities_water_use[city_selected.name].percent_turf * 100)
        : 0,
      color: "#43B99E",
    },
    {
      name: "Exchange",
      y: cities_water_use[city_selected.name]
        ? Math.round(
            cities_water_use[city_selected.name].percent_exchange * 100
          )
        : 0,
      color: "#718CD4",
    },
    {
      name: "Tap Water",
      y: cities_water_use[city_selected.name]
        ? Math.round(
            cities_water_use[city_selected.name].percent_tap_water * 100
          )
        : 0,
      color: "#2352D0",
    },
  ];

  const handleChange = (value) => {
    loadCityMetrics(value);
    var cityFound = cities.find((item) => item.value === (value));
    setSelectedCity(cityFound);
    loadEntityEntitlements(value, scenario_selected.value);
    loadCityWaterSources(value);
    setIsTribe(false);
    setIsWesternEntity(false);

    /** Update the city in the route */
    history.push({
      pathname: `/visualizations/honeycomb`,
      search:  "?" + new URLSearchParams({type: "cities", dropdown: cityFound?.label}).toString()
    });
  }

  /** Set the redux state(selected_city) to the value present in the dropdown section of the Route */
  useEffect(() => {
    if(dropdown && cities?.length) {
      var entityFound = cities.find((item) => item?.label?.toLowerCase() === (dropdown?.toLowerCase()));
      if(entityFound) {
        loadCityMetrics(entityFound?.value);
        setSelectedCity(entityFound)
        loadEntityEntitlements(entityFound?.value, scenario_selected?.value);
        setIsWesternEntity(false);
        setIsCity(true);
        loadCityWaterSources(entityFound?.value);
        setIsTribe(false);
      }
    }
  }, [dropdown, cities])

  return (
    <>
      {/* <Typography variant="body2" component="div" className={classes.cityTitle}>
        {city_selected.name}
      </Typography> */}
      {/* Title replaced with location filter */}
      <ColoradoRiverAccessLocationFilter
        location_options={cities}
        handleChange={handleChange}
        city_id={city_selected.city_id}
        style={{ marginLeft: 26 }}
        autocomplete={true}
      />
      <br/>
      <ChartSidebarAccordion group_name={`Entity Summary`} accordion_name={'entity'} >
      <Typography
        variant="body2"
        component="div"
        className={classes.metricSubTitle}
      >
        Population Served
      </Typography>
      <Typography variant="h6" component="div" className={classes.metricValue1}>
      {population != null && city_selected.name in population ? population[city_selected.name].toLocaleString("en-US") + " people" : "Data coming soon"} 
      </Typography>
      <Typography
        variant="body2"
        component="div"
        className={classes.metricSubTitle}
      >
        Colorado water access
      </Typography>
      <Typography variant="h6" component="div" className={classes.metricValue1}>
        {entity_entitlements[entitlement_year]
          ? Math.round(
              entity_entitlements[entitlement_year].total_co_access
            ).toLocaleString("en-US")
          : 0}{" "}
        ac-ft
      </Typography>

      {/* {central_az_tab === "per_capita" &&  */}
      {polgon_map_tab === "per_capita" && (
        <>
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
            Access change from 2024
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue1}
          >
            {entitlements_by_year[city_selected.city_id]
              ? Math.round(
                  entitlements_by_year[city_selected.city_id].access_change_start
                ).toLocaleString("en-US")
              : "Xxx,xxx"}{" "}
            ac-ft (
            {entitlements_by_year[city_selected.city_id]
              ? Math.round(
                  entitlements_by_year[city_selected.city_id]
                    .percent_access_change_start
                )
              : "xx"}
            %)
          </Typography>
        </>
      )}
      </ChartSidebarAccordion>
      {
          Object.keys(city_water_sources).length !== 0?
          (
            <ChartSidebarAccordion group_name={`Tap Water Sources - 2020`} accordion_name={'tap_water_sources'}>
              <PolygonMapSidebarChart chart_data={chartDataWaterSources} />
            </ChartSidebarAccordion>
          )
          : (
            <ChartSidebarAccordion group_name={`Tap Water Sources - 2020`} accordion_name={'tap_water_sources'}>
              <Typography
                variant="body2"
                component="div"
                className={classes.metricSubTitle}
              >
                Results coming soon
              </Typography>
            </ChartSidebarAccordion>
          )
          
        }

        {
          Object.keys(city_water_sources).length !== 0?
          (
            <ChartSidebarAccordion group_name={`${city_selected.name} Water Uses - 2020`} accordion_name={'water_uses'}>
              <PolygonMapSidebarChart chart_data={chartDataWaterUse} />
            </ChartSidebarAccordion>
          )
          : (
            <ChartSidebarAccordion group_name={`${city_selected.name} Water Uses - 2020`} accordion_name={'water_uses'}>
              <Typography
                variant="body2"
                component="div"
                className={classes.metricSubTitle}
              >
                Results coming soon
              </Typography>
            </ChartSidebarAccordion>
          )
          
        }
    </>
  );
}

export default PolygonMapChartTab;
